import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { TrainerImage } from '@lean-body/components/atoms/trainer_img';
import * as routes from '@lean-body/src/route';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export const InstructorContent = (props) => {
    const styles = StyleSheet.create({
        container: {
            cursor: 'pointer',
            width: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            [MediaBreakPointUp.SM]: {
                width: '33.33%',
            },
            [MediaBreakPointUp.MD]: {
                marginBottom: 10,
                width: '25%',
            },
            [MediaBreakPointUp.LG]: {
                marginBottom: 18,
                width: '20%',
            },
        },
        label: {
            letterSpacing: 1,
            fontSize: 16,
            marginBottom: 16,
            fontWeight: 'bold',
            lineHeight: '1.25',
            [MediaBreakPointUp.SM]: {
                fontSize: 18,
            },
        },
    });
    const onClickTrainerDetail = () => {
        return props.router.push(routes.INSTRUCTOR, {
            id: props.trainer.id.toString(),
        });
    };
    return (React.createElement("div", { onClick: onClickTrainerDetail, className: css(styles.container) },
        React.createElement(TrainerImage, { trainer: props.trainer }),
        React.createElement("div", { className: css(styles.label) }, props.trainer.name)));
};
